import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VerticalAlignTopIcon(props: IconProps) {
    return <Icon {...props} iconKey={"vertical_align_top"}/>
}
